const getItemId = item =>
  typeof item === 'object' && item !== null ? item.id : item

export const getSelectionRange = (orderedItems, anchorId, targetId) => {
  const anchorIndex = orderedItems.findIndex(
    item => getItemId(item) === anchorId
  )
  const targetIndex = orderedItems.findIndex(
    item => getItemId(item) === targetId
  )

  if (anchorIndex === -1 || targetIndex === -1) return []

  const start = Math.min(anchorIndex, targetIndex)
  const end = Math.max(anchorIndex, targetIndex)
  return orderedItems.slice(start, end + 1)
}

export const mergeUniqueSelection = (selectedItems, additionalItems) => {
  const byId = new Map(selectedItems.map(item => [getItemId(item), item]))
  additionalItems.forEach(item => byId.set(getItemId(item), item))
  return Array.from(byId.values())
}

export const getIntersectingItemIds = (itemRects, selectionRect) => {
  const selectionLeft = Math.min(selectionRect.left, selectionRect.right)
  const selectionTop = Math.min(selectionRect.top, selectionRect.bottom)
  const selectionRight = Math.max(selectionRect.left, selectionRect.right)
  const selectionBottom = Math.max(selectionRect.top, selectionRect.bottom)

  return Array.from(itemRects.entries())
    .filter(([, itemRect]) =>
      itemRect.left < selectionRight &&
      itemRect.right > selectionLeft &&
      itemRect.top < selectionBottom &&
      itemRect.bottom > selectionTop
    )
    .sort(([, first], [, second]) =>
      first.top === second.top
        ? first.left - second.left
        : first.top - second.top
    )
    .map(([id]) => id)
}

export const haveSameSelection = (first, second) =>
  first.length === second.length &&
  first.every((id, index) => id === second[index])

export const hasExceededDragThreshold = (
  start,
  current,
  threshold = 10
) =>
  Math.max(
    Math.abs(current.x - start.x),
    Math.abs(current.y - start.y)
  ) > threshold

export const getAutoScrollSpeed = (
  pointerY,
  viewportHeight,
  edgeSize = 90,
  maxSpeed = 24
) => {
  if (pointerY > viewportHeight - edgeSize) {
    const ratio = Math.min(
      1,
      (pointerY - (viewportHeight - edgeSize)) / edgeSize
    )
    return Math.max(4, Math.ceil(maxSpeed * ratio))
  }

  if (pointerY < edgeSize) {
    const ratio = Math.min(1, (edgeSize - pointerY) / edgeSize)
    return -Math.max(4, Math.ceil(maxSpeed * ratio))
  }

  return 0
}

export const isTextEditingTarget = target =>
  Boolean(
    target?.closest?.(
      'input, textarea, select, [contenteditable="true"], [role="textbox"], [role="dialog"], .MuiModal-root'
    )
  )
